import {Container, Spinner} from '@chakra-ui/react';

export const LoadingSpinner: React.FC = () => {
  return (
    <Container
      py='30px'
      centerContent
    >
      <Spinner
        color='brand.500'
        aria-label='Chargement...'
      />
    </Container>
  );
};
